import Styleguide, { Colors, theme } from "../theme";
import styled from "styled-components";

const TextPrimary = styled.h1`
  font-family: ${Styleguide.fonts.heading.name};
  font-size: ${Styleguide.fontSizes[24]};
  font-weight: ${Styleguide.fontWeights.bold};
  text-align: center;
  color: ${theme(Colors.gray[400], Colors.white)};
  margin: 16px 0;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    font-size: ${Styleguide.fontSizes[32]};
  }
`;

export default TextPrimary;
